import { useState } from "react";
import { HiDocument } from "react-icons/hi";
import resume from "../assets/files/AgbelesheDanielMayowa.pdf";
import logo from "../assets/files/logoNoBg.png";

const Header = () => {
  const [clicked, setClicked] = useState(false);

  return (
    <header className="py-8">
      <div className="container mx-auto">
        <div className="flex justify-between">
          {/* my logo */}
          <div className="w-[150px] flex">
            <img
              src={logo}
              alt="logo"
              className="h-10 md:h-14 w-10 md:w-14 rounded-md"
            />
            <a className="hidden md:block" href="#">
              <h1 className="text-gradient text-[1.7rem] font-bolder">
                Daniel
              </h1>
              <h1 className="text-3xl font-extrabold">Agbeleshe</h1>
            </a>
          </div>

          {/* Resume button */}
          <a
            href={resume}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setClicked(true)}
            className={`btn btn-sm font-bold text-sm flex items-center gap-2 ${
              clicked ? "" : "animate-pulse"
            }`}
          >
            View My Resume{" "}
            <span className="hidden md:inline-block">
              <HiDocument />
            </span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
